var keyboardTypeMap = {
  "default": 'text',
  'ascii-capable': 'text',
  'numbers-and-punctuation': 'number',
  url: 'url',
  'number-pad': 'number',
  'phone-pad': 'tel',
  'name-phone-pad': 'text',
  'email-address': 'email',
  'decimal-pad': 'number',
  twitter: 'text',
  'web-search': 'search',
  numeric: 'number'
};
export default keyboardTypeMap;